import { actions } from 'xstate';

const { log } = actions;

/**
 * Log out the context and event for any xstate event.
 */
export const logDetails = log(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (context: any, event: any): string =>
        `Context: ${JSON.stringify(context, null, 4)}\nEvent: ${JSON.stringify(
            event,
            null,
            4,
        )}\n-------------`,
);
